export default "__VITE_ASSET__DTGwgbw___"